import { HStack, Text } from '@chakra-ui/react';
import { TransactionSide } from '@client/graphql/__generated__/types';

interface SideToggleProps {
  selectedSide: TransactionSide;
  onSideChange: (side: TransactionSide) => void;
}

export const SideToggle = ({ selectedSide, onSideChange }: SideToggleProps) => {
  const sides = [
    { value: TransactionSide.BUY, label: 'Buy side' },
    { value: TransactionSide.SELL, label: 'Sell side' },
  ];

  return (
    <HStack px={6} py={5} spacing={4}>
      {sides.map((side) => {
        const isSelected = selectedSide === side.value;

        return (
          <Text
            key={side.value}
            _hover={{ opacity: isSelected ? 1 : 0.6 }}
            color="white"
            cursor="pointer"
            fontSize="2xl"
            fontWeight="medium"
            opacity={isSelected ? 1 : 0.3}
            transition="opacity 0.2s"
            onClick={() => onSideChange(side.value)}
          >
            {side.label}
          </Text>
        );
      })}
    </HStack>
  );
};
